import * as Yup from 'yup';
import { OfficeProfileRo } from '@/types';

const WEBSITE_REGEX = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/;

export const MAX_SMALL_LOGO_FILE_SIZE_MB = 50;
export const MAX_BANNER_FILE_SIZE_MB = 50;
export const MAX_SMALL_LOGO_FILE_SIZE_BYTES = MAX_SMALL_LOGO_FILE_SIZE_MB * 1_000_000;
export const MAX_BANNER_FILE_SIZE_BYTES = MAX_BANNER_FILE_SIZE_MB * 1_000_000;

export const ALLOWED_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/bmp',
] as const;

export const ALLOWED_IMAGE_ACCEPT = ALLOWED_IMAGE_MIME_TYPES.join(',');

const trimTrailingZeros = (value: string) => value.replace(/\.?0+$/, '');

export const formatMaxSizeMbLabel = (mb: number): string =>
  Number.isInteger(mb) ? String(mb) : trimTrailingZeros(mb.toFixed(1));

export const formatFileSizeMb = (bytes: number): string => {
  const mb = bytes / 1_000_000;
  if (mb < 1) return trimTrailingZeros(mb.toFixed(2));
  return trimTrailingZeros(mb.toFixed(1));
};

export const validationSchema = (t: (key: string) => string) =>
  Yup.object({
    about: Yup.string(),
    directLink: Yup.string()
      .required(t('form.required'))
      .matches(/^[a-zA-Z0-9_-]+$/, t('form.wrongDirectLink'))
      .min(3, t('form.wrongDirectLinkMin'))
      .max(255, t('form.wrongDirectLinkMax')),
    email: Yup.string().email(t('form.wrongEmail')),
    phone: Yup.string().matches(/^\+\d{7,15}$/, {
      message: t('form.wrongPhone'),
      excludeEmptyString: true,
    }),
    website: Yup.string()
      .transform((value) => (typeof value === 'string' ? value.trim() : value))
      .matches(WEBSITE_REGEX, { message: t('form.wrongWebsite'), excludeEmptyString: true }),
    address: Yup.string(),
    founded: Yup.string(),
    regions: Yup.string(),
  });

export type BrokerProfileFormValues = Yup.InferType<ReturnType<typeof validationSchema>>;

export const getInitialValues = (profile?: OfficeProfileRo): BrokerProfileFormValues => ({
  about: profile?.aboutUs ?? '',
  directLink: profile?.directLink ?? '',
  email: profile?.email ?? '',
  phone: profile?.phone ?? '',
  website: profile?.site ?? '',
  address: profile?.address ?? '',
  founded: profile?.founded ? String(profile.founded) : '',
  regions: profile?.region ?? '',
});
